import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  Routes,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from "react-router-dom";

import { browserApiErrorsIntegration } from "@sentry/browser";

import { DEVELOPMENT, PRODUCTION } from "../constants/constants";
// Utility to determine environment
const getEnvironment = () => {
  // Use REACT_APP_SENTRY_ENVIRONMENT if set, else fallback to NODE_ENV, else 'production'
  //   Add this to .env file
  return (
    process.env.REACT_APP_SENTRY_ENVIRONMENT ||
    process.env.NODE_ENV ||
    PRODUCTION
  );
};

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: getEnvironment(),

    integrations: [
      Sentry.browserTracingIntegration(),

      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      Sentry.browserProfilingIntegration(),
      Sentry.browserSessionIntegration(),
      browserApiErrorsIntegration()
    ],
    // add prod const
    tracesSampleRate: getEnvironment() === PRODUCTION ? 0.25 : 1.0,
    profilesSampleRate: getEnvironment() === PRODUCTION ? 0.25 : 1.0,
    tracePropagationTargets: [/^\/api\//, /^\//],

    // add dev const

    debug: getEnvironment() === DEVELOPMENT,
    normalizeDepth: 10,
    maxBreadcrumbs: 50
  });
} else {
  console.warn("Sentry DSN not set. Skipping Sentry initialization.");
}

// Export Sentry-wrapped Routes for use in your app
const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export { SentryRoutes };
